import dayjs from 'dayjs';
export const getChartOption = (data, t1)=>({
        tooltip: {
            trigger: 'item'
        },
        legend: {
            orient: 'vertical',
            left: 0,
            data: [
                t1('c_w_jekka_conv_manual'),
                t1('c_w_jekka_conv_auto')
            ],
            itemWidth: 8,
            itemHeight: 8,
            top: 36,
            textStyle: {
                color: '#333'
            },
            color: [
                '#1663FF',
                '#1CC6FF',
                '#FF8A02'
            ],
            icon: 'circle',
            backgroundColor: 'transparent',
            borderWidth: 0,
            itemGap: 15,
            formatter: function(name) {
                const dataMap = {
                    Jekka转人工会话量: data === null || data === void 0 ? void 0 : data.operator_conversation_num,
                    纯AI接待会话量: data === null || data === void 0 ? void 0 : data.ai_conversation_num
                };
                return `${name} ${dataMap[name]}`;
            }
        },
        series: [
            {
                type: 'pie',
                center: [
                    '80%',
                    '50%'
                ],
                radius: [
                    '40%',
                    '72%'
                ],
                avoidLabelOverlap: false,
                color: [
                    '#1CC6FF',
                    '#FF8A02'
                ],
                itemStyle: {
                    borderRadius: 2,
                    borderColor: '#fff',
                    borderWidth: 1
                },
                data: [
                    {
                        value: data === null || data === void 0 ? void 0 : data.operator_conversation_num,
                        name: t1('c_w_jekka_conv_manual')
                    },
                    {
                        value: data === null || data === void 0 ? void 0 : data.ai_conversation_num,
                        name: t1('c_w_jekka_conv_auto')
                    }
                ],
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                },
                label: {
                    show: false
                },
                labelLine: {
                    show: false
                }
            }
        ]
    });
/**
 * 公共图表数据
 * 机器人解决率数据配置
 * Jekka机器人平均响应时长数据配置
 * Jekka机器人接待人数
 */ export const getArrOptions = (list, config)=>{
    var _list_, _list_1, _list_2, _list_3, _list_4, _list_5;
    if (!(list === null || list === void 0 ? void 0 : list.length)) return {
        series: []
    };
    const { field, beforeField, name, unit = '', color = '#1663FF', areaColor } = config;
    const seriesData = [
        {
            value: ((_list_ = list[0]) === null || _list_ === void 0 ? void 0 : _list_[beforeField ?? field]) ?? 0,
            start_date: (_list_1 = list[0]) === null || _list_1 === void 0 ? void 0 : _list_1.compare_start_date,
            end_date: (_list_2 = list[0]) === null || _list_2 === void 0 ? void 0 : _list_2.compare_end_date
        },
        {
            value: ((_list_3 = list[1]) === null || _list_3 === void 0 ? void 0 : _list_3[field]) ?? 0,
            start_date: (_list_4 = list[1]) === null || _list_4 === void 0 ? void 0 : _list_4.start_date,
            end_date: (_list_5 = list[1]) === null || _list_5 === void 0 ? void 0 : _list_5.end_date
        }
    ];
    const dates = seriesData.map((item)=>item.start_date);
    return {
        tooltip: {
            trigger: 'axis',
            appendToBody: true,
            formatter: (params)=>{
                var _p_data, _p_data1;
                const p = params[0];
                const rawValue = (p === null || p === void 0 ? void 0 : p.value) ?? 0;
                let value;
                if (unit === '%' || unit === '秒') {
                    value = Number(rawValue).toFixed(2);
                } else {
                    value = rawValue;
                }
                const startDate = p === null || p === void 0 ? void 0 : (_p_data = p.data) === null || _p_data === void 0 ? void 0 : _p_data.start_date;
                const endDate = p === null || p === void 0 ? void 0 : (_p_data1 = p.data) === null || _p_data1 === void 0 ? void 0 : _p_data1.end_date;
                return `
          <div style="margin-bottom:6px;">${name}: ${value}${unit}</div>
          <div style="margin-bottom:6px;">${t('c_w_start_date')}: ${startDate ? dayjs(startDate).format('YYYY-MM-DD') : ''}</div>
          <div>${t('c_w_end_date')}: ${endDate ? dayjs(endDate).format('YYYY-MM-DD') : ''}</div>
        `;
            }
        },
        legend: null,
        grid: {
            top: 20,
            left: '3%',
            right: '4%',
            bottom: 3,
            containLabel: true,
            backgroundColor: '#F0F6FF',
            borderColor: 'transparent',
            borderWidth: 0
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: dates,
            axisLabel: {
                color: '#333',
                show: false
            },
            splitLine: {
                show: false
            },
            axisLine: {
                show: false
            },
            axisTick: {
                show: false
            } // 隐藏左右黑点
        },
        yAxis: {
            type: 'value',
            axisLabel: {
                color: '#333',
                show: false
            },
            splitLine: {
                show: false
            },
            formatter: `{value}${unit}`
        },
        series: [
            {
                name,
                type: 'line',
                data: seriesData,
                color,
                smooth: true,
                lineStyle: {
                    width: 3
                },
                itemStyle: {
                    color,
                    symbol: 'none'
                },
                areaStyle: {
                    color: areaColor
                }
            }
        ]
    };
};
